// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"grid-module--gridWrapper--3zokv","cardWrapper":"grid-module--cardWrapper--1x4NL"};